export { default } from './EntityCard';
